import React, { useState, useEffect } from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import "./styles/gxon.css"; // Correct Gxon styles to avoid Vite "global" identifier conflict

import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ptBR } from "@material-ui/core/locale";
import createGxonTheme from "./theme"; // Import Gxon theme
import { useThemeContext } from "./context/DarkMode";

const App = () => {
  const [locale, setLocale] = useState();
  const { darkMode } = useThemeContext();

  // Create theme based on dark mode setting
  const theme = createGxonTheme(darkMode ? "dark" : "light");

  useEffect(() => {
    const i18nlocale = localStorage.getItem("i18nextLng");
    const browserLocale =
      i18nlocale.substring(0, 2) + i18nlocale.substring(3, 5);

    if (browserLocale === "ptBR") {
      setLocale(ptBR);
    }
  }, []);

  // Apply dark mode class to body
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [darkMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes />
    </ThemeProvider>
  );
};

export default App;

